<template>
  <mep-carousel :card-variant :slides="[Ref10, Ref11, Ref12, Ref13]" @slide-change="$emit('slide-change', $event)" />
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue';

withDefaults(
  defineProps<{
    cardVariant?: 'inline' | 'modal';
  }>(),
  {
    cardVariant: 'inline',
  }
);

const Ref10 = defineAsyncComponent(() => import('./MepRef10.vue'));
const Ref11 = defineAsyncComponent(() => import('./MepRef11.vue'));
const Ref12 = defineAsyncComponent(() => import('./MepRef12.vue'));
const Ref13 = defineAsyncComponent(() => import('./MepRef13.vue'));
</script>
